import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import {
  getFullScenario,
  getReservedSubTimes,
  getReservedTimes,
} from "../../api/routes";
import getMinutes from "components/getMinutes";
import useStyle from "./style";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import useModal from "../../hooks/useModal";
import FillTimeModal from "./FillTimeModal";
import MDButton from "../../components/MDButton";
import { useNavigate } from "react-router-dom";
import useMe from "../../hooks/useMe";
import { toast } from "react-toastify";

export default function FillTime() {
  const classes = useStyle();
  const navigate = useNavigate()
  const m = moment();
  const [me] = useMe()
  const [fullScenario, setFullScenario] = useState([]);
  const [clickedScenario, setClickedScenario] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [reservedTimes, setReservedTimes] = useState([]);
  const [reservedSubTimes, setReservedSubTimes] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    day: parseInt(moment().locale("fa").format("D")),
    month: parseInt(moment().locale("fa").format("M")),
    year: parseInt(moment().locale("fa").format("YYYY")),
  });
  const [trigger, setTrigger] = useState(null);
  const [modals, updateModal, closeModal] = useModal({ fillTime: { state: false } });

  const handleChange = (event, item) => {
    const data = {
      reservationDayId: item.reservationDayId,
      requestGroupId: item.requestGroupId,
      subRequestGroupId: item.subRequestGroupId,
      subTime: item.time,
      reservationDate: item.reservationDate,
      isReserved: event.target.checked,
    };
    updateModal("fillTime", {
      state: true,
      data,
      reservedSubTimesId: reservedSubTimes.find(item2 => item2.subTime === item.time)?.reservedSubTimesId,
    });
  };

  useEffect(() => {
    const FORMATTED_DATE = `${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`;
    setLoading(true);
    getFullScenario(FORMATTED_DATE, (isOk, data) => {
      setLoading(false);
      if (!isOk) return toast.error(data.message);
      else return setFullScenario(data);
    });
  }, [selectedDate]);
  useEffect(() => {
    if (clickedScenario) {
      setLoading(true);
      getReservedTimes(clickedScenario.requestGroupId, clickedScenario.subRequestGroupId, clickedScenario.reservationDate, clickedScenario.reservationDayId, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data?.message);
        } else {
          setReservedTimes(data);
          if (!data?.length) {
            setReservedSubTimes([]);
            setLoading(false);
            return;
          }
          getReservedSubTimes(clickedScenario.requestGroupId, clickedScenario.reservationDate, clickedScenario.subRequestGroupId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
              setLoading(false);
              return setReservedSubTimes(data);
            }
          }, trigger !== null);
        }
      });
    }
  }, [clickedScenario, trigger]);

  let subTimes = reservedSubTimes.map((item) => item.subTime);
  const subTimesList = [];
  reservedTimes?.map((item) => {
    const divideHours = Math.floor(getMinutes(item.startTime, item.endTime) / item.patientNumber);
    for (let j = 0; j < item.patientNumber; j += 1) {
      subTimesList.push({
        fullNameGroup: item.fullNameGroup,
        endReservationTime: item.endReservationTime,
        reservationDate: item.reservationDate,
        requestGroupId: item.requestGroupId,
        subRequestGroupId: item.subRequestGroupId,
        reservationDayId: item.reservationDayId,
        time: moment(item.startTime, "HH:mm").add(divideHours * j, "minutes").format("HH:mm"),
      });
    }
  });
  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref}
      placeholder="تاریخ"
      value={selectedDate ? `${selectedDate?.year}/${selectedDate?.month}/${selectedDate?.day}` : ""}
      className={classes.calendarInput}
    />
  );
  return (
    <>
      <DashboardLayout>
        <MDBox pt={2} mb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <MDTypography variant="h6" color="white">
                    پرکردن تایم
                  </MDTypography>
                  <DashboardNavbar />
                </MDBox>
                {(me.role === "center" || me.role === "reservation") && <MDButton style={{ color: "white", width: 200, borderRadius: 20, margin: "1rem 1rem 0 0" }}
                            onClick={() => navigate("/fill-time/viewFillTime?collapseNavbar=1")}
                            variant="gradient"
                            color="warning">
                    مشاهده جزئیات
                  </MDButton>}
                <MDBox py={6} px={3}>
                  <DatePicker
                    value={selectedDate}
                    onChange={setSelectedDate}
                    renderInput={renderCustomInput}
                    selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
                    selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
                    minimumDate={{
                      year: Number(m?.locale("fa")?.format("YYYY")),
                      month: Number(m?.locale("fa")?.format("MM")),
                      day: Number(m?.locale("fa")?.format("DD")),
                    }}
                    wrapperClassName={classes.wrapperClassName}
                    shouldHighlightWeekends
                    locale="fa"
                    colorPrimary="#0fbcf9"
                    colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                  />
                  <FormControl className={classes.scenarioInput}>
                    <InputLabel>سناریو</InputLabel>
                    <Select
                      renderValue={(item) => moment(`${String(item.reservationDate).slice(0, 4)}/${String(item.reservationDate).slice(4, 6)}/${String(item.reservationDate).slice(6)}`, "jYYYY/jM/jD").locale("fa").format("LLLL").slice(0, -11) + " - ساعت " + item.startTime + " تا " + item.endTime + " - " + item.fullNameGroup.split(" - ")[1]}
                      label="سناریو" sx={{ height: "44.3px" }} value={clickedScenario} onChange={(event) => {
                      setClickedScenario(event.target.value);
                    }}>
                      {fullScenario && fullScenario.map((item) =>
                        <MenuItem key={item.reservationDayId}
                                  value={item}>{moment(`${String(item.reservationDate).slice(0, 4)}/${String(item.reservationDate).slice(4, 6)}/${String(item.reservationDate).slice(6)}`, "jYYYY/jM/jD").locale("fa").format("LLLL").slice(0, -11) + " - ساعت " + item.startTime + " تا " + item.endTime + " - " + item.fullNameGroup.split(" - ")[1]}</MenuItem>,
                      )}
                    </Select>
                  </FormControl>
                  <div className={classes.subTimeParent}>
                    {subTimesList.map((time, index) =>
                      <section key={index} style={{
                        background: subTimes.includes(time.time) && !reservedSubTimes[reservedSubTimes.findIndex(element => element.subTime === time.time)].isPanel ? "#ccc" : "#eeffde",
                        border: subTimes.includes(time.time) && !reservedSubTimes[reservedSubTimes.findIndex(element => element.subTime === time.time)].isPanel ? "2px solid #ccc" : "1px solid #5ec700",
                        width: "120px",
                        height: "50px",
                        margin: "4px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                        <Checkbox color="secondary"
                                  checked={subTimes.includes(time.time) && reservedSubTimes[reservedSubTimes.findIndex(element => element.subTime === time.time)].isPanel}
                                  onChange={(event) => !(subTimes.includes(time.time) && !reservedSubTimes[reservedSubTimes.findIndex(element => element.subTime === time.time)].isPanel) && handleChange(event, time)} />
                        <p style={{ fontSize: "18px" }}>{time.time}</p>
                      </section>,
                    )}
                  </div>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Footer />
        {modals.fillTime.state &&
          <FillTimeModal modal={modals.fillTime} setTrigger={setTrigger} handleClose={() => closeModal("fillTime")} />}
      </DashboardLayout>
    </>
  );
}
